import { useTranslations } from "next-intl";
import { SCard } from "@/components/Card/SCard";
import { Spacing } from "@/components/Spacing/Spacing";
import { useSearchParams } from "@/hooks/useSearchParams";
import { AuthLayout } from "./AuthLayout";
import RegisterForm from "./register/RegisterForm";
import InviteRegisterForm from "./register/InviteRegisterForm";

export function RegisterPage() {
  const t = useTranslations("register");
  const searchParams = useSearchParams();
  // Invitees arrive via /auth/register?invite_code=… — they keep the legacy
  // full-form flow (the email-first split is self-serve only for now).
  const isInvite = Boolean(searchParams.get("invite_code"));

  return (
    <AuthLayout>
      <SCard
        width="w-[95vw] sm:max-w-150"
        header={t("registerTitle")}
        outline="outline-quaternary"
        shadow="shadow-xl"
      >
        <Spacing height="h-6" />
        {isInvite ? <InviteRegisterForm /> : <RegisterForm />}
      </SCard>
    </AuthLayout>
  );
}
